import {
  Home,
  Plus,
  Library,
  Compass,
  User,
  Settings,
  Award,
  Calendar,
  Star,
  ToolCase,
  UploadCloud,
  Users,
  MessageSquare,
  Bell,
  LogOut,
  Film,
  Briefcase,
} from "lucide-react";

export const NAV_LINKS = [
  { name: "Home", href: "/home", icon: Home },
  { name: "Create", href: "/create", icon: Plus, isCentral: true },
  { name: "Dreamworld Pro", href: "/pro", icon: Star },
  { name: "Library", href: "/library", icon: Library },
  { name: "Editing Chats", href: "/editing-chats", icon: MessageSquare },
  { name: "Uploads", href: "/uploads", icon: UploadCloud },
  { name: "Discover", href: "/discover", icon: Compass },
  { name: "Events", href: "/events", icon: Calendar },
  { name: "Film director", href: "/film-director", icon: Film },
  { name: "Brand & Marketing", href: "/brand-marketing", icon: Briefcase },
  { name: "Settings", href: "/settings", icon: Settings },
  { name: "Logout", href: "/login", icon: LogOut },
];
export const MOBILE_NAV_LINKS = [
  { name: "Home", href: "/home", icon: Home },
  { name: "Discover", href: "/discover", icon: Compass },
  {
    name: "Editing Chats",
    href: "/editing-chats",
    icon: MessageSquare,
    isCentral: false,
  },
  { name: "Library", href: "/library", icon: Library },
  { name: "Profile", href: "/profile", icon: User },
];

export const EXCLUDED_ROUTES = [
  "/login",
  "/register",
  "/onboarding",
  "/landing",
];
